import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import { t } from '../../i18n/t';
import ChartCanvas from './ChartCanvas';
import { CHART_HIST, defaultPlot, drawAxes, linMap } from './senseCapChartDraw';

type RrHistogramChartProps = {
    binEdges: number[];
    counts: number[];
};

const RrHistogramChart = ({ binEdges, counts }: RrHistogramChartProps) => {
    const draw = useCallback(
        (ctx: CanvasRenderingContext2D, size: { width: number; height: number }) => {
            if (binEdges.length < 2 || !counts.length) return;
            const plot = defaultPlot(size.width, size.height);
            const xMin = binEdges[0];
            const xMax = binEdges[binEdges.length - 1];
            const yMin = 0;
            const yMax = Math.max(...counts, 1);

            drawAxes(
                ctx,
                plot,
                t('sensecap.axisRrMs'),
                t('sensecap.axisCount'),
                xMin,
                xMax,
                yMin,
                yMax,
            );

            ctx.fillStyle = CHART_HIST;
            for (let i = 0; i < counts.length; i++) {
                const x0 = linMap(binEdges[i], xMin, xMax, plot.left, plot.right);
                const x1 = linMap(binEdges[i + 1], xMin, xMax, plot.left, plot.right);
                const y = linMap(counts[i], yMin, yMax, plot.bottom, plot.top);
                const w = Math.max(x1 - x0 - 1, 1);
                ctx.fillRect(x0, y, w, Math.max(plot.bottom - y, 1));
            }
        },
        [binEdges, counts],
    );

    if (counts.length < 1 || binEdges.length < 2) {
        return (
            <Typography color="text.secondary" variant="body2">
                {t('sensecap.hrvEmpty')}
            </Typography>
        );
    }

    return <ChartCanvas draw={draw} height={240} />;
};

export default RrHistogramChart;
